module.exports = __webpack_public_path__ + "img/4.80cd5353.jpg";